// extracted by mini-css-extract-plugin
export default {"applicationHeader":"ApplicationDetails_applicationHeader__AeRnj","detailsContailer":"ApplicationDetails_detailsContailer__u0fce"};